import React, { useEffect, useRef, useState } from "react";

import ClearIcon from "@mui/icons-material/Clear";

const NotificationTemplete = ({ notification, onClick, onRemove }) => {
  const [isHovering, setIsHovering] = useState(false);
  const timerRef = useRef(null);

  useEffect(() => {
    if (!isHovering) {
      timerRef.current = setTimeout(() => {
        onRemove(notification.id);
      }, 5000);
    }

    return () => clearTimeout(timerRef.current);
  }, [isHovering, notification.id, onRemove]);

  return (
    <>
      <div
        onMouseEnter={() => setIsHovering(true)}
        onMouseLeave={() => setIsHovering(false)}
        onClick={onClick}
        className="animate-fade-in flex  relative items-start gap-4 p-4 bg-white border border-blue-200 rounded-xl shadow-xl w-80 cursor-pointer transition-all"
      >
        <button
          onClick={(e) => {
            e.stopPropagation();
            onRemove(notification.id);
          }}
          className=" absolute   top-2  right-2  h-8  flex items-center justify-center w-8 overflow-hidden p-1 rounded-full border"
        >
          <ClearIcon />
        </button>
        <div className="text-blue-600 mt-1">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-6 w-6 text-blue-600"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
            />
          </svg>
        </div>
        <div className="flex-1 text-gray-800">
          <div className="font-semibold text-base mb-1">
            🔔 {notification?.type}
          </div>
          <div className="text-sm">{notification.message}</div>
        </div>
      </div>
    </>
  );
};

export default NotificationTemplete;
